import {useState} from "react";
import {ZapleczeAdminMenu, ZapleczeAdminMenuList, ZapleczeAdminPanel} from "../ZapleczeAdmin";
import {ZapleczeHeader} from "../ZapleczeHeader";
import Box from "@mui/material/Box";


export const ZapleczeAdmin = (
    {
        token,
        pageTitle,
        user,
        contextList,
        setSelectedContext,
        selectedContext,
        isAdmin

    }
) => {
    const[menuIx, setMenuIx] = useState(ZapleczeAdminMenuList.NONE);

    return (
        <>
            <ZapleczeHeader pageTitle={pageTitle}
                            user={user.name}
                            isAdmin={isAdmin}
                            contextList={contextList}
                            setSelectedContext={setSelectedContext}
                            selectedContext={selectedContext}
            >
                <ZapleczeAdminMenu setMenuIx={setMenuIx} isAdmin={isAdmin}/>
            </ZapleczeHeader>

            <Box className='main-panel'>

                <ZapleczeAdminPanel token={token}
                                    isAdmin={isAdmin}
                                    selectedContext={selectedContext}
                                    menuIx={menuIx}
                />

            </Box>
        </>
    )
}
